export default "__VITE_ASSET__cbb998ab__"